import { getIbanCheckIssue, getPayableAmounts } from "@msuite/utils/incoming-invoices";
import type { IncomingInvoiceReviewFormSchema } from "@msuite/utils/schemas";
import type { IncomingInvoiceDetail } from "@msuite/utils/types";
import { shareOf } from "@/forms/incoming-invoice-cost-allocation-form";

/**
 * The review form as it opens on an invoice: the cost allocation the step before accepted — the
 * AI's suggestion for the first step — and the Kürzung already on the invoice, if any. It opens
 * on a rejection while the IBAN check keeps accepting out of reach.
 *
 * @param incomingInvoice - The invoice as just read.
 * @returns The form's default values.
 */
export function toReviewFormValues(
	incomingInvoice: IncomingInvoiceDetail,
): IncomingInvoiceReviewFormSchema {
	const payable = getPayableAmounts(incomingInvoice);
	const netAmount = payable.netAmount ?? 0;
	return {
		state: getIbanCheckIssue(incomingInvoice.checks) ? "rejected" : "approved",
		comment: null,
		allocations: incomingInvoice.costAllocations.map((allocation) => ({
			costCenterId: allocation.costCenter.id,
			amount: allocation.amount,
			share: shareOf(allocation.amount, netAmount),
		})),
		isReduced: payable.isReduced,
		reducedNetAmount: incomingInvoice.reducedNetAmount,
		reductionReason: incomingInvoice.reductionReason,
	};
}
